import { createContext } from "react";

export interface CameraContextInterface {
	takePicture: () => string | undefined;
}

const cameraContext = createContext<CameraContextInterface | null>(null);

export default cameraContext;
